export const HOURS = Array.from({ length: 24 }, (_, hour) => hour);

const curve = (points) => HOURS.map((hour) => {
  const next = points.findIndex(([at]) => at >= hour);
  if (next <= 0) return points[0][1];
  const [leftHour, leftValue] = points[next - 1];
  const [rightHour, rightValue] = points[next];
  return Math.round((leftValue + (rightValue - leftValue) * (hour - leftHour) / (rightHour - leftHour)) * 10) / 10;
});

export const DAILY_PRESETS = {
  daytime: curve([[0, 2], [5, 2], [8, 5], [12, 7], [16, 7], [19, 5], [23, 2]]),
  morningEvening: curve([[0, 2], [5, 2], [8, 8], [12, 4], [16, 5], [19, 9], [23, 3]]),
  evening: curve([[0, 2], [6, 2], [12, 4], [16, 5], [19, 10], [23, 4]]),
  night: curve([[0, 8], [5, 8], [9, 3], [17, 2], [21, 7], [23, 8]]),
};

export function legacyHourlyProfile(weights, useCase) {
  const fallback = useCase === "Commercial" ? [5, 35, 45, 15] : [12.5, 25, 35, 27.5];
  const values = ["earlyMorning", "morning", "afternoon", "evening"].map((key, i) => {
    const raw = weights?.[key];
    return raw == null || raw === "" ? 0 : Math.max(0, Number(raw) || 0);
  });
  const blocks = values.some((value) => value > 0) ? values : fallback;
  return HOURS.map((hour) => blocks[Math.floor(hour / 6)] / 6);
}

export function profileTotal(values) {
  if (!Array.isArray(values) || values.some((value) => value === "" || !Number.isFinite(Number(value)) || Number(value) < 0)) return NaN;
  return values.reduce((sum, value) => sum + Number(value), 0);
}

export function profileValidation(values) {
  if (!Array.isArray(values) || values.length !== 24) return "length";
  const total = profileTotal(values);
  if (!Number.isFinite(total)) return "value";
  return Math.abs(total - 100) <= 1e-6 ? null : "total";
}

export function normalizeProfile(values) {
  const total = profileTotal(values);
  if (!Number.isFinite(total) || total <= 0) return null;
  const result = values.map((value) => Math.round(Number(value) / total * 100 * 1e8) / 1e8);
  const largest = result.indexOf(Math.max(...result));
  const correction = Math.round((100 - result.reduce((sum, value) => sum + value, 0)) * 1e8) / 1e8;
  result[largest] = Math.round((result[largest] + correction) * 1e8) / 1e8;
  return result;
}

export function hourlyProfile(values) {
  if (!Array.isArray(values) || ![24, 96].includes(values.length)) return null;
  const source = normalizeProfile(values);
  if (!source) return null;
  if (source.length === 24) return source;
  // Saved 15-minute profiles are read as hourly shares for compatibility.
  return normalizeProfile(HOURS.map((hour) => source.slice(hour * 4, hour * 4 + 4).reduce((sum, value) => sum + value, 0)));
}

export function presetProfile(key) {
  return hourlyProfile(DAILY_PRESETS[key]);
}

export function selectedDailyPreset(values) {
  if (!Array.isArray(values) || ![24, 96].includes(values.length)) return "custom";
  const normalized = hourlyProfile(values);
  return Object.keys(DAILY_PRESETS).find((key) => {
    const preset = presetProfile(key);
    return normalized?.every((value, index) => Math.abs(value - preset[index]) < 1e-6);
  }) || "custom";
}

